import { store, getContext, getElement } from '@wordpress/interactivity';
import blockDef from './block.json';
import {
  state as tabLayoutState,
  actions as tabLayoutActions,
} from '../TabLayout/front';

store(blockDef.amplify.viewNamespace, {
  state: {
    get isSelected() {
      const context = getContext();
      if (!Number.isInteger(context.index)) {
        return false;
      }

      return tabLayoutState.selectedIndex === context.index;
    },
  },

  actions: {
    onClick: () => {
      const context = getContext();
      tabLayoutActions.setSelectedIndex(context.index);
      console.log(
        `[TabButton#onClick] tabLayoutState.selectedIndex:`,
        tabLayoutState.selectedIndex
      );
    },
  },

  callbacks: {
    init: () => {
      const context = getContext();
      console.log(`[TabButton#init] context:`, context);
      const { ref } = getElement();
      console.log(`[TabButton#init] element content:`, ref.innerText);
      context.index = Array.from(ref?.parentElement?.children).indexOf(ref);
      console.log(`[TabButton#init] button index:`, context.index);
      console.log(
        `[TabButton#init] tabLayoutState.selectedIndex:`,
        tabLayoutState.selectedIndex
      );
    },
  },
});
